const startsWithHttps = (url: string) => /^(https?)/.test(url)

export default startsWithHttps
